import { useSelector } from 'react-redux';
import { usePasswordConfirm } from 'helpers';
import DeleteForever from '@mui/icons-material/DeleteForever';
import { Icon } from '@mui/material';
import styles from './childAudit.module.css';

export default function AuditorListItem({ auditor, handleRevoke, date }) {
	const { email } = auditor;
	const { isSm } = useSelector(({ mediaQuery }) => mediaQuery);
	const onPasswordConfirm = usePasswordConfirm();

	return (
		<div className={styles.auditorListItemRoot}>
			<div className={styles.auditorListItemInfo}>
				<div className={styles.auditorItem}>{email}</div>
				<div className={styles.auditorItem}>{`valid through ${date}`}</div>
			</div>
			{handleRevoke && (
				<div
					className={styles.auditorListRevokeButton}
					onClick={() =>
						onPasswordConfirm(
							(e) => handleRevoke(e),
							`To revoke auditor access for ${email}, please confirm your password`
						)
					}>
					{!isSm ? (
						'Revoke Access'
					) : (
						<Icon>
							<DeleteForever />
						</Icon>
					)}
				</div>
			)}
		</div>
	);
}
